import { ArrowUp, ArrowDown } from 'lucide-react';
import { LOG_TYPE } from '@/constants';

export function ArrowUpOrDown({ type }: { type: string }) {
  if (
    type === LOG_TYPE.GIFT_CREATED
    || type === LOG_TYPE.WITHDRAW
    || type === LOG_TYPE.WITHDRAW_FEE
  ) {
    return <ArrowUp className="w-6 h-6 min-w-6" />;
  }

  return <ArrowDown className="w-6 h-6 min-w-6" />;
}